
import "./Belge.css";
import React from 'react'

export default function Belge() {
    return (
        <div className="row belgeholder" style={{margin:"auto",padding:"1%",backgroundColor:"#F6EBF0",height:"auto"}}>
                        
           
            

            <div className="col-md-6 col-sm-12 col-12 tanıtım" style={{paddingTop:"2rem",paddingRight:"3rem"}}>
                <p  style={{textAlign:"center",fontWeight:"bold"}}>协会基本信息</p>
                <p  style={{}}><b>中文名称 :</b> 中国公民和中国公司（企业）法律权益保护和援助协会 <br/>
                <b>土文名称 :</b> Çin Vatandaş ve Çin Şirketleri Hukuki Hak ve Menfaatlerini Koruma ve Yardımlaşma Derneği <br/><br/>
                <b>注册地址 ：</b>土耳其、安卡拉省政府 <br/>
                <b>协会代表（会长/首席执行长）:</b> 赵跃 <br/>
                <b>注册号 ：</b>06-142-088 <br/>
                <b>注册回执时间 ：</b> 2020年11月3日14.15 <br/>
                <b>审批时间 ：</b> （内政部）2020年9月16日</p>
                <p  style={{}}><b>目前规模 : </b> 政府审核管理核心会员3人（安卡拉法律专职人员）
          协会核心会员8人
          协会会计师   2人
          协会审核外围会员12人（伊斯坦布尔、伊兹密尔、安塔利亚、加济安泰普、尙勒乌鲁法、宛、萨姆顺、恩迪勒奈等大中城市法律专职人员，以上城市外围人员均具有执业资质并在该律所以协会成员分支机构资质协助总部协会工作）。
            </p><br/>

            <p style={{}}><b>协会国际地位 : </b>目前是全世界范围内首家以中国公民和企业直接命名并获得所在国政府直接认可的司法保护和援助协会。</p>
            <br/>
            <p  style={{}}><b>国际联盟协会 : </b> 已经获得位于美国“法律盾牌(简称”律盾”联盟)司法联盟”加入申请。
            并获得该联盟高级成员和高级执委资格。目的保护在世界范围内居住华人、华企针对土耳其域内的维权保护。
            该联盟目前在世界100多个国家具有分会。
            该协会联盟意在世界范围内针对华人、华企合法权益进行司法协作和联合保护。</p>
              
            </div>

            

            <div className="col-md-6 col-sm-12 col-12 alındı" style={{paddingTop:"2rem"}}>
                <p style={{textAlign:"center"}}>土耳其共和国 <br/>
                安卡拉省政府 <br/>
                省民间社会关系局</p>
               
                
                <div style={{display:"inline"}}>
                    <p style={{float:"left"}}><b>编号 : </b> 74071012-477.01.01-145526</p>
                    <p style={{float:"right"}}>03.11.2020</p>
                </div>
                <br/>
                <br/>
                
                <p style={{float:"left"}}><b>科目 : </b> 成立协会（编号：06-142-088）</p>
                <br/>
                <br/>
                <br/>
                <h4 className="alındıbaslık" style={{textAlign:"center",fontWeight:"bold"}}>回执(注册)证明文件</h4>
                <p style={{}}><b>回执申请日期 : </b> 03.11.2020</p>
                <p style={{}}><b>时间  : </b> 14:15 <br/>
                <b>协会名称 : </b> 中国公民和中国公司法律权益保护和援助协会 <br/>
                <b>住所地址 : </b> Mehmet Akif Ersoy Mahallesi M.A.E Cad. No:7  Yenimahalle/ ANKARA <br/><br/>
                根据4721号土耳其民法的第59条法令。收到的上述书写的名称和住所地址的协会声明和附件符合注册要求。
                </p>
                <br/>
                <br/>
                <div style={{display:"inline"}}>
                    <p style={{float:"left"}}>回执（注册）证明发证人</p>
                    <p style={{float:"right"}}>回执（注册）证明收到人</p>
                    
                </div>
                <br/>
                <br/>
                <div style={{display:"inline"}}>
                    <p style={{float:"left"}}>HALUK TEBER</p>
                    <p style={{float:"right"}}>YUE ZHAO </p>
                </div>
                <br/>
                <br/>
                <div style={{display:"inline"}}>
                    <p style={{float:"left"}}>省民间社会关系局长 </p>
                    <p style={{float:"right"}}>协会成立人员 </p>
                </div>
                
                    
            </div>

            
        
    
</div>
    )
}
